module.exports = __webpack_public_path__ + "img/12_97.35526d50.png";